export default __webpack_public_path__ + "static/media/1183.79359649.png";